import { useNavigation } from 'modules/core/hooks/useNavigation'

import { PayrollPhase, PayrollStatus } from 'modules/payroll_bundle/lib/enums'
import { getPayrollPhase } from 'modules/payroll_bundle/store/models/PolicyPeriod'

import { PathSegment } from './types'

interface Params {
  status: PayrollStatus
  policyId: PathSegment
  policyPeriodId: PathSegment
  navigation: ReturnType<typeof useNavigation>['navigation']
}

export default function pathForPolicyPeriodStatus({
  status,
  policyId,
  policyPeriodId,
  navigation,
}: Params): string {
  const phase = getPayrollPhase(status)
  switch (phase) {
    case PayrollPhase.SUPPLEMENTS_DEFINITION:
      return navigation.payrollBundle.policy.period.cycles.supplements.fullPath({
        policyId: policyId,
        periodId: policyPeriodId,
      })
    case PayrollPhase.PAYROLL_CALCULATION:
      return navigation.payrollBundle.policy.period.cycles.results.fullPath({
        policyId: policyId,
        periodId: policyPeriodId,
      })
    case PayrollPhase.PAYMENT:
      return navigation.payrollBundle.policy.period.cycles.payments.fullPath({
        policyId: policyId,
        periodId: policyPeriodId,
      })
    default:
      const _exhaustiveCheck: never = phase
      throw new Error(`Unhandled status: ${_exhaustiveCheck}`)
  }
}
